// OneTrust stores accepted group IDs in window.OnetrustActiveGroups as ",1,2,3,4,"
// 4 = Targeted/Advertising cookies (the category YouTube falls under)
// ⚠ Confirm this ID and the UpdateConsent API format against the OneTrust dashboard.
const TARGETING_GROUP_ID = "4";

export const hasTargetingConsent = (): boolean =>
  (window.OnetrustActiveGroups ?? "").split(",").includes(TARGETING_GROUP_ID);

export const acceptTargetingConsent = (): void => {
  window.OneTrust?.UpdateConsent("Category", `${TARGETING_GROUP_ID}:1`);
};
